import { render, staticRenderFns } from "./memberSosClickLogTab.vue?vue&type=template&id=c4716a52&lang=pug"
import script from "./memberSosClickLogTab.vue?vue&type=script&lang=js"
export * from "./memberSosClickLogTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports